import { generateApiActionTypes } from 'utils/actions/generateActionTypes'
import { ENDPOINTS } from 'utils/api/callApi'
import { prepareSaveLanesRequestData } from 'apps/carrier/utils/lanes'
import { IRate, IRateAPI } from 'apps/marketplace/store/contractLanes/types'
import { keymirror } from 'utils/keymirror'

export const CARRIER_LANES_ACTION_TYPES = generateApiActionTypes('CARRIER_LANES')
export const fetchCarrierLanes = (carrierApplicationId: string) => ({
  type: '',
  payload: {
    callApi: true,
    requestData: {
      endpoint: ENDPOINTS.contractLanes,
      method: 'GET',
      params: {
        filters: {
          carrierApplicationId,
          includes: ['dat_market_lane', 'carrier_application_offer_limits'],
        },
        perPage: 1000,
      },
    },
    actionTypes: Object.keys(CARRIER_LANES_ACTION_TYPES),
  },
})

export const APPROVE_LANE_ACTION_TYPES = generateApiActionTypes('APPROVE_LANE')
export const approveLane = ({ contractId }: IRate) => ({
  payload: {
    callApi: true,
    requestData: {
      endpoint: ENDPOINTS.contractLanes,
      method: 'PUT',
      id: contractId,
      group: 'approve',
    },
    actionTypes: Object.keys(APPROVE_LANE_ACTION_TYPES),
  },
})

export const REMOVE_LANE_MODAL_ACTION_TYPES = keymirror({
  REMOVE_LANE_MODAL_OPEN: undefined,
  REMOVE_LANE_MODAL_CLOSE: undefined,
})
export const openRemoveLaneModal = (lane: IRate) => ({
  type: REMOVE_LANE_MODAL_ACTION_TYPES.REMOVE_LANE_MODAL_OPEN,
  payload: { lane },
})
export const closeRemoveLaneModal = () => ({
  type: REMOVE_LANE_MODAL_ACTION_TYPES.REMOVE_LANE_MODAL_CLOSE,
})

export const REMOVE_LANES_ACTION_TYPES = generateApiActionTypes('REMOVE_LANES')
export const removeLanes = (contractIds: number[]) => ({
  payload: {
    callApi: true,
    requestData: {
      endpoint: ENDPOINTS.contractLanes,
      method: 'POST',
      group: 'batch_process_lanes',
      body: {
        contractLanes: contractIds.map(carrierContractLaneId => ({
          carrierContractLaneId,
          _destroy: true,
        })),
      },
    },
    actionTypes: Object.keys(REMOVE_LANES_ACTION_TYPES),
  },
})

export const LANE_MODAL_ACTION_TYPES = keymirror({
  LANE_MODAL_OPEN: undefined,
  LANE_MODAL_CLOSE: undefined,
})
export const openLaneModal = (lane?: IRate) => ({
  type: LANE_MODAL_ACTION_TYPES.LANE_MODAL_OPEN,
  payload: { lane },
})
export const closeLaneModal = () => ({
  type: LANE_MODAL_ACTION_TYPES.LANE_MODAL_CLOSE,
})

export const SAVE_LANES_ACTION_TYPES = generateApiActionTypes('SAVE_LANES')
export const saveLanes = (lane: IRateAPI) => ({
  payload: {
    callApi: true,
    requestData: prepareSaveLanesRequestData(lane, 'carrier_profile'),
    actionTypes: Object.keys(SAVE_LANES_ACTION_TYPES),
  },
})

export const LANE_CREATED_MODAL_ACTION_TYPES = keymirror({
  LANE_CREATED_MODAL_OPEN: undefined,
  LANE_CREATED_MODAL_CLOSE: undefined,
})
export const openLaneCreatedModal = () => ({
  type: LANE_CREATED_MODAL_ACTION_TYPES.LANE_CREATED_MODAL_OPEN,
})
export const closeLaneCreatedModal = () => ({
  type: LANE_CREATED_MODAL_ACTION_TYPES.LANE_CREATED_MODAL_CLOSE,
})
